import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(private title: Title) { }

  updateTitle(title: string) {
    const prev = this.host;
    this.title.setTitle(prev + title);
  }

  setTitle() {
    if (environment.production) {
      this.title.setTitle('MarketPlace - Auction & Exchange');
    } else {
      this.title.setTitle('MarketPlace - Auction & Exchange - India');
    }
  }

  get host() {
    if (environment.production) {
      return 'MarketPlace - Auction & Exchange - ';
    } else {
      return 'MarketPlace - Auction & Exchange - India - ';
    }
  }
}
